/* eslint-disable no-console */
'use client'

import { useEffect } from 'react'
import type { ReactNode } from 'react'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'

interface PostHogProviderProps {
  children: ReactNode
  apiKey?: string | null
  apiHost?: string | null
}

export function PostHogProvider({
  children,
  apiKey,
  apiHost,
}: PostHogProviderProps) {
  useEffect(() => {
    if (apiKey) {
      posthog.init(apiKey, {
        api_host: apiHost ?? '',
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
        defaults: '2025-05-24',
      })
    } else {
      console.warn(
        `PostHog key is not set. Please set POSTHOG_KEY in your environment variables. PostHog will not be initialised. ${!!apiKey}, ${apiHost}`,
      )
    }
  }, [apiKey, apiHost])

  return <PHProvider client={posthog}>{children}</PHProvider>
}
